module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "showmodel"
  }, [_c('div', {
    staticClass: "showmodel_1 display_wrap_as set_yj"
  }, [_c('titles', {
    attrs: {
      "titles": "详细信息"
    }
  }), _vm._v(" "), _vm._l((_vm.editInfo), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "showmodel_1hz display_row_ac media_w_showmodel1hz"
    }, [_c('div', {
      staticClass: "showmodel_1hz_1 display_row_jc_ac dispaly_flex00"
    }, [_c('span', [_vm._v(_vm._s(item.name) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: "showmodel_1hz_2 display_row_ac dispaly_flex11 "
    }, [_c('span', [_vm._v(_vm._s(item.value))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "showmodel_1hz display_row_ac media_w_showmodel2hz",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "showmodel_1hz_2 display_row_ac dispaly_flex11 "
  }, [_c('span', [_vm._v(_vm._s(_vm.comments))])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "showmodel_1hz_1 display_row_jc_ac dispaly_flex00"
  }, [_c('span', [_vm._v("备注:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3aa26266"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/user/showmodel.vue
// module id = 1070
// module chunks = 1